import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPositions } from 'api';
import { getTempEmployeeAvailableColumns } from './api';

export const path = '/admin/temp-employee/list';

const PageTempEmployee: React.FC = (props) => {
  const TempEmployee = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getTempEmployeeAvailableColumns,
      positions: getPositions,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page: any = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TempEmployee {...props} />;
};

export default PageTempEmployee;
